module.exports = __webpack_public_path__ + "img/6.c13108d3.jpg";